import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-[#080a0f] text-white flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-6 py-20 w-full">
        <h1 className="text-3xl font-bold text-white mb-2">Política de Privacidad</h1>
        <p className="text-[#6b7280] text-sm mb-10">Última actualización: 1 de abril de 2025</p>

        <div className="space-y-10 text-[#a8b2c1] text-sm leading-relaxed">

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">1. Responsable del tratamiento</h2>
            <p>
              El responsable del tratamiento de sus datos personales es <strong className="text-white">Apuestamente</strong>, con dirección de contacto en{' '}
              <a href="mailto:apuestamente@gmail.com" className="text-[#00e87a] hover:underline">apuestamente@gmail.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">2. Datos que recopilamos</h2>
            <p className="mb-3">Recopilamos los siguientes tipos de datos personales:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li><strong className="text-white">Datos de registro:</strong> nombre de usuario, dirección de correo electrónico y contraseña cifrada.</li>
              <li><strong className="text-white">Datos de perfil:</strong> foto de perfil, descripción, historial de apuestas registradas voluntariamente.</li>
              <li><strong className="text-white">Datos de pago:</strong> procesados de forma segura por Stripe; Apuestamente no almacena datos de tarjetas.</li>
              <li><strong className="text-white">Datos de uso:</strong> páginas visitadas, funcionalidades utilizadas, dirección IP y tipo de dispositivo.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">3. Finalidad del tratamiento</h2>
            <p className="mb-3">Utilizamos sus datos para:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Gestionar su cuenta y prestar los servicios contratados.</li>
              <li>Procesar pagos y gestionar suscripciones.</li>
              <li>Enviar comunicaciones relacionadas con el servicio (alertas, notificaciones).</li>
              <li>Mejorar la Plataforma mediante análisis de uso agregado y anonimizado.</li>
              <li>Cumplir con obligaciones legales aplicables.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">4. Base legal del tratamiento</h2>
            <p>
              El tratamiento de sus datos se basa en la ejecución del contrato de prestación de servicios (art. 6.1.b RGPD), el cumplimiento de obligaciones legales (art. 6.1.c RGPD) y, en su caso, el consentimiento expreso del usuario (art. 6.1.a RGPD).
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">5. Conservación de datos</h2>
            <p>
              Sus datos se conservarán mientras mantenga una cuenta activa en la Plataforma. Tras la cancelación de la cuenta, los datos se eliminarán en un plazo máximo de 30 días, salvo que la legislación aplicable exija su conservación por un período mayor.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">6. Cesión de datos a terceros</h2>
            <p className="mb-3">
              No vendemos ni cedemos sus datos personales a terceros con fines comerciales. Compartimos datos únicamente con proveedores de servicios necesarios para el funcionamiento de la Plataforma:
            </p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li><strong className="text-white">Supabase:</strong> almacenamiento de base de datos y autenticación.</li>
              <li><strong className="text-white">Stripe:</strong> procesamiento de pagos.</li>
              <li><strong className="text-white">Google Analytics:</strong> análisis de tráfico anonimizado.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">7. Sus derechos</h2>
            <p className="mb-3">De acuerdo con el RGPD, usted tiene derecho a:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li><strong className="text-white">Acceso:</strong> conocer qué datos tenemos sobre usted.</li>
              <li><strong className="text-white">Rectificación:</strong> corregir datos inexactos o incompletos.</li>
              <li><strong className="text-white">Supresión:</strong> solicitar la eliminación de sus datos.</li>
              <li><strong className="text-white">Portabilidad:</strong> recibir sus datos en formato estructurado.</li>
              <li><strong className="text-white">Oposición:</strong> oponerse al tratamiento en determinadas circunstancias.</li>
            </ul>
            <p className="mt-3">
              Para ejercer estos derechos, contacte con nosotros en{' '}
              <a href="mailto:apuestamente@gmail.com" className="text-[#00e87a] hover:underline">apuestamente@gmail.com</a>.
              También puede presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD).
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">8. Seguridad</h2>
            <p>
              Aplicamos medidas técnicas y organizativas adecuadas para proteger sus datos frente a accesos no autorizados, pérdida o destrucción, incluyendo cifrado en tránsito (TLS) y en reposo, control de accesos y auditorías periódicas.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">9. Cambios en esta política</h2>
            <p>
              Podemos actualizar esta Política de Privacidad periódicamente. Le notificaremos cualquier cambio significativo por correo electrónico o mediante un aviso destacado en la Plataforma.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}
